import api from '@swarm/core/services/api'
import { useQuery } from '@tanstack/react-query'

const useRwaStats = () => {
  return useQuery({
    queryKey: ['getRwaStats'],
    queryFn: api.getRwaStats,
  })
}

export default useRwaStats
